import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { ExplanationAccordion, LabelField } from 'components'
import * as controllers from 'controllers'
import { SettingsVehicleReleaseDateInformationDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import VehicleReleaseAddEditDialog from './VehicleReleaseAddEditDialog'

export default function VehicleReleaseListCard() {
  const [vehicleReleaseAddEditDialogOpen, setVehicleReleaseAddEditDialogOpen] = useState<boolean>(false)
  const [isGettingVehicleReleaseDateInformation, setIsGettingVehicleReleaseDateInformation] = useState<boolean>(false)
  const [isSavingVehicleReleaseDateInformation, setIsSavingVehicleReleaseDateInformation] = useState<boolean>(false)
  const [vehicleReleaseDateInformation, setVehicleReleaseDateInformation] = useState<SettingsVehicleReleaseDateInformationDto>(
    new SettingsVehicleReleaseDateInformationDto()
  )

  useEffect(() => {
    setIsGettingVehicleReleaseDateInformation(true)
    controllers
      .getVehicleReleaseDateInformation()
      .then(response => {
        setVehicleReleaseDateInformation(response.value)
      })
      .finally(() => {
        setIsGettingVehicleReleaseDateInformation(false)
      })
  }, [])

  return (
    <>
      <VehicleReleaseAddEditDialog
        initialValues={vehicleReleaseDateInformation}
        isLoading={isSavingVehicleReleaseDateInformation}
        onClose={() => {
          setVehicleReleaseAddEditDialogOpen(false)
        }}
        onSave={values => {
          setIsSavingVehicleReleaseDateInformation(true)
          controllers
            .updateVehicleReleaseDateInformation(values)
            .then(response => {
              enqueueSnackbar('Vehicle Release Date Information Saved Successfully!', { variant: 'success' })
              setVehicleReleaseDateInformation(response.value)
              setVehicleReleaseAddEditDialogOpen(false)
            })
            .finally(() => {
              setIsSavingVehicleReleaseDateInformation(false)
            })
        }}
        open={vehicleReleaseAddEditDialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Vehicle Release Date
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button
                  onClick={() => {
                    setVehicleReleaseAddEditDialogOpen(true)
                  }}
                  variant='text'
                  endIcon={<Edit />}
                >
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingVehicleReleaseDateInformation && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!isGettingVehicleReleaseDateInformation && (
              <Grid item xs={12}>
                <LabelField
                  label='Number of Days After Conformity Submitted DOT'
                  value={vehicleReleaseDateInformation.vehicleReleaseNumberOfDaysAfterConformitySubmittedDOT}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                ||This is typically configured as 30 days due to the 30-day vehicle hold required by the DOT.||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
